<ng-container *ngIf="showReporte">
    <ng-container *ngFor="let elemento of elementos">
        <div class="card-print my-3" [ngClass]="elementosClasses[elemento]" *ngIf="validaData(elemento)">
            <mat-card>                
                <mat-card-content>
                    <div class="row p-5">
                        <div class="col-12 mx-auto">
                            <ng-container [ngSwitch]="elemento">
                                <ng-container *ngSwitchCase="'rentabilidad'">
                                    <app-line-bars id="rentabilidad" [serie]='rentabilidadGraph.serie' [title]='rentabilidadGraph.title'
                                        [yAxix]="rentabilidadGraph.yAxix" [categorias]='rentabilidadGraph.categorias'
                                        [plotOptions]="rentabilidadGraph.plotOptions"
                                    ></app-line-bars>
                                </ng-container>
                                <ng-container *ngSwitchCase="'liquidez'">
                                    <app-line-bars id="liquidez" [serie]='liquidezGraph.serie' [title]='liquidezGraph.title' [yAxix]="liquidezGraph.yAxix"
                                        [categorias]='liquidezGraph.categorias' [plotOptions]="liquidezGraph.plotOptions"
                                    ></app-line-bars>
                                </ng-container>
                                <ng-container *ngSwitchCase="'cobertura'">
                                    <app-line-bars id="cobertura" [serie]='coberturaGraph.serie' [title]='coberturaGraph.title'
                                        [yAxix]="coberturaGraph.yAxix" [categorias]='coberturaGraph.categorias'
                                        [plotOptions]="coberturaGraph.plotOptions"
                                    ></app-line-bars>
                                </ng-container>
                                <ng-container *ngSwitchCase="'eficiencia'">
                                    <app-line-bars id="eficiencia" [serie]='eficienciaGraph.serie' [title]='eficienciaGraph.title'
                                        [yAxix]="eficienciaGraph.yAxix" [categorias]='eficienciaGraph.categorias'
                                        [plotOptions]="eficienciaGraph.plotOptions"
                                    ></app-line-bars>
                                </ng-container>
                                <ng-container *ngSwitchCase="'estructuraFinanciera'">
                                    <div class="graph-estructura-financiera mx-auto">
                                        <app-line-bars id="estructuraFinanciera" [serie]='estructuraFinancieraGraph.serie' [title]='estructuraFinancieraGraph.title'
                                            [yAxix]="estructuraFinancieraGraph.yAxix" [categorias]='estructuraFinancieraGraph.categorias'
                                            [plotOptions]="estructuraFinancieraGraph.plotOptions"
                                        ></app-line-bars>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'ventasNetas'">
                                    <div id="ventasNetas" [chart]="ventasNetasGraph"></div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'comprasNetas'">
                                    <div id="comprasNetas" [chart]="comprasNetasGraph"></div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'comprasVentasNetas'">
                                    <div class="graph-compra-venta mx-auto">
                                        <div id="comprasVentasNetas" [chart]="comprasVentasNetasGraph"></div>
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchDefault></ng-container>
                            </ng-container>
                        </div>
                    </div>
    
                </mat-card-content>
            </mat-card>
        </div>
    </ng-container>
</ng-container>
